import { inject, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectListPrepaidsQuery = ({ vendorId }: { vendorId: Signal<string> }) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    enabled: !!vendorId(),
    queryFn: () =>
      gqlToPromise(() => {
        return gqlService.listPrepaids$({
          vendor_id: vendorId(),
        });
      }),
    queryKey: [
      'trials',
      'detail',
      mainQuery.trialKey(),
      'list-prepaids',
      {
        vendor_id: vendorId(),
      },
    ],
  }));
};
